import Axios from 'axios';
import { Field } from 'formik';
import React, { Component } from 'react'
import { Input } from 'semantic-ui-react';

export default class CityNameComponent extends Component {

    state = {
        cityName: []
    }

    componentDidMount() {
        this.fetchCityName(this.props.cityId)
        console.log(this.props)
    }
    fetchCityName = (city_id) => {
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let gett = localStorage.getItem("apiToken");
        let congData = JSON.stringify
            ({
                customerNo: +customerNo,
                customer_no: +customerNo,
                customerNumber: +customerNo,
                userId: +userId
            })
        let resp = Axios.post(`${process.env.REACT_APP_MAIN_URL}/masters/cityMaster/${+city_id}`, congData, {
            headers: {
                Authorization: `${gett}`,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }
        });
        // return resp.data ? resp.data.resultSet[0].cityName : ''
        resp.then((fetch) => {
            this.setState({ cityName: fetch.data.resultSet })
            // console.log(">>>", fetch.data.resultSet[0].cityName)
        })

    }
    render() {
        // console.log(this.state.cityName)
        return (
            <>
                {this.props.type === 'addBranchType' ? <Field className="mt-3 textarea-class" value={this.state.cityName.length > 0 ? this.state.cityName[0].cityName : 'N/A'} /> :
                    this.state.cityName.length > 0 ? this.state.cityName[0].cityName : 'N/A'
                }
            </>
        )
    }
}
